import { UncontrolledCollapse, Table, Col, Container, Row, Card, CardBody, Input, Button, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, Form, ModalBody, ModalFooter, Label, ModalHeader, FormFeedback, Spinner, CardHeader, CardFooter } from "reactstrap";
import { isEmpty, clone } from "lodash";
import logo from "../../../assets/images/users/user-dummy-img.jpg";
import { api } from "../../../config";
import { Link } from "react-router-dom";
import defaultImg from "../../../assets/images/users/user-dummy-img.jpg";
import moment from "moment";
import parse from "html-react-parser";
import Flatpickr from "react-flatpickr";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import handleValidDateTime from "../../../helpers/utils/handleValidDateTime";
import ModalImage from "react-modal-image";
import { useEffect, useState } from "react";
const CardBoard = (props) => {
  useEffect(() => {
    if (props.isLoadingDeal === false) {
      props.handleSubmitLoading(null);
    }
  }, [props.isLoadingDeal]);
  const sendDataToParent = () => {
    let datas = [];
    props.data.deal_user.forEach((item) => {
      datas.push({ label: item.deal_user_user.name, value: item.deal_user_user.id });
    });
    const updateDealPatch = {
      id: props.data ? props.data.id : 0,
      image: props.data.image,
      description: "",
      value: props.data.value,
      tag: JSON.stringify(props.data.tag),
      statusId: props.data.statusId,
      customerId: props.data.customerId,
      brandId: props.data.brandId,
      branchId: props.data.branchId,
      companyId: props.data.companyId,
      clientId: props.data.clientId,
      files: props.data.deal_file,
      startat: props.data.startat,
      endat: props.data.endat,
      dealuser: datas,
      name: props.data.name,
      statusDealId: props.data.statusDealId,
      deal_product: JSON.stringify(props.data.deal_product),
      action: "tanggal_akad",
    };
    props.handleSubmitLoading(updateDealPatch.id);
    props.onChildProps(updateDealPatch);
  };
  let history = props.history;
  const handleEndAt = (date) => {
    props.data.endat = date;
  };

  const berkasPlaced = moment(props.data.startat);
  const orderCompleted = props.data.targetat ? moment(props.data.targetat) : moment();
  const durationBerkas = orderCompleted.diff(berkasPlaced);
  const leadTimeBerkas = moment.duration(durationBerkas);

  const diffDays = orderCompleted.diff(berkasPlaced, 'days');

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${fileName}-w-50`} large={`${api.MEDIA_URL}/media/${fileName}`} alt={props.data.name} className="img-thumbnail avatar-xs img-thumbnail user-profile-image" />;
    }
  };

  return (
    <>
      <Card
        className="mb-2 border-1"
        style={{
          border: "1px solid rgb(204, 204, 204)",
          whiteSpace: "normal",
        }}
      >
        <CardBody className="mb-0 p-0">
          <div className="d-flex align-items-center">
            {/* <div className="flex-shrink-0">
              <img
                style={{
                  pointerEvents: "none",
                }}
                src={props.image === "" ? logo : `${api.MEDIA_URL}/media/${props.image}`}
                alt=""
                className="avatar-xs rounded-circle" />
            </div> */}
            <div className="flex-grow-1 ms-3">
              <div className="mb-1">
                <h6 className="fs-14 mb-1 user-select-none">{props.data?.legal_per_document?.name}</h6>
                {props.data.startat && <p>Lead time: <span className="fw-semibold">{diffDays} Hari</span></p>}
                <p className="text-muted mb-0 user-select-none">{props.data?.description}</p>
              </div>
            </div>
          </div>

          {/* <i className="mdi mdi-chevron-down ms-1"></i> */}
        </CardBody>
        <CardFooter className="d-flex gap-2 justify-content-between">
          <Button
            color="light"
            onClick={() => {
              // let data = {
              //   // ...object,
              //   id: props.data.id,
              //   type: "Status",
              //   companyId: props.data.companyId,
              //   clientId: props.data.clientId,
              //   statusDealId: props.data.statusDealId,
              // };
              props.handleToggleUpdate(props.data);
            }}
            className="btn btn-sm"
            style={{
              width: "60px",
            }}><i className="ri-edit-line align-bottom me-1"></i>
          </Button>
          <Button
            color="light"
            onClick={() => {
              // let data = {
              //   // ...object,
              //   id: props.data.id,
              //   type: "Status",
              //   companyId: props.data.companyId,
              //   clientId: props.data.clientId,
              //   statusDealId: props.data.statusDealId,
              // };
              props.handleToggleMailing(props.data);
            }}
            className="btn btn-sm"
            style={{
              width: "60px",
            }}><i className="ri-newspaper-line align-bottom me-1"></i>
          </Button>

          <UncontrolledButtonDropdown>
            <DropdownToggle
              tag="button"
              color="light"
              className="btn btn-sm"
              style={{
                width: "60px"
              }}
              split>
              <i className="ri-printer-line align-bottom me-1"></i>
            </DropdownToggle>
            <DropdownMenu container="body">
              <DropdownItem
                onClick={() => {
                  props.handleToggleMailingPrint(props.data, "print-siteplan");
                }}>
                SITEPLAN
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  props.handleToggleMailingPrint(props.data, "print-peli-banjir");
                }}>
                PEIL BANJIR
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  props.handleToggleMailingPrint(props.data, "print-jembatan");
                }}>
                PEKERJAAN TAMBAH
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  props.handleToggleMailingPrint(props.data, "print-rumija");
                }}>
                RUMIJA
              </DropdownItem>
              {/* <DropdownItem
                onClick={() => {
                  props.handleToggleMailingPrint(props.data, "print-sk-penetapan");
                }}>
                SK PENETAPAN
              </DropdownItem> */}
            </DropdownMenu>
          </UncontrolledButtonDropdown>

          <Link
            color="light"
            className="btn btn-sm"
            style={{
              width: "60px",
            }}
            to="#"
            id={"leadInnerDiscovered" + props.id}><Button
              color="info"
              className="btn-sm mt-1"
              style={{
                width: "60px",
              }}>
              <i className="ri-eye-line align-bottom me-1"></i>
            </Button>
          </Link>
        </CardFooter>
        <UncontrolledCollapse className="border-top border-top-dashed" toggler={"#leadInnerDiscovered" + props.id} defaultOpen={false}>
          <CardBody className="bg-light ">
            {(props.data.legal_per_file || []).map((file, key) => {
              let src;
              return (
                <div key={key + "filehak"} className="cursor-pointer d-flex"
                  onClick={() => {
                    const typeFile = file.filename.split(".");
                    if (typeFile[typeFile.length - 1] === "x-compressed") {
                      window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                    } else if (typeFile[typeFile.length - 1] === "sheet") {
                      window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                    } else if (typeFile[typeFile.length - 1] === "pdf") {
                      window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                    } else {
                      //
                    }
                  }}>
                  <div className="flex-shrink-0 fs-17 me-2 filelist-icon" style={{width: "50px"}}>
                    <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                  </div>
                  <div className="flex-grow-1 text-start">
                    <p className="fw-semibold mb-1 mt-1">{file.description}</p>
                    <p>{file.originalname}</p>
                  </div>
                </div>
              );
            })}

          </CardBody>
        </UncontrolledCollapse>
      </Card>
    </>
  );
};

export default CardBoard;
